import tasksService from '../../services/tasksService.js';
import dataModel from '../../models/DataModel';
import ReduxConstants from '../../constants/ReduxConstants.js';
import _ from 'lodash';
import AOCollection from './AOCollection.js';

// TODO: can this be combined with TasksAssignedByProjectCollection?
export default class TasksAssignedByProjectCollection extends AOCollection {

  constructor(projectId, userId, companyId, subKey, recordDescriptor) {
    super({
      name: ReduxConstants.MY_PROJECT_TASKS,
      collectionType: ReduxConstants.TASK,
      userId,
      companyId, 
      subKey: projectId + (subKey ? '_'+subKey : ''),
      recordDescriptor,
    });
    this._projectId = projectId;
    this.processItemActionCable = this.processItemActionCable.bind(this);
  }

  static build(projectId, userId, companyId, subKey, recordDescriptor) {
    const collection = new TasksAssignedByProjectCollection(projectId, userId, companyId, subKey, recordDescriptor);
    let collectionData = dataModel.collectionsDAO.findCollection(collection.getKey());
    if (!collectionData) {
      collectionData = dataModel.collectionsDAO.setCollection(collection.getKey(), collection.getDefaultData(), collection.getCollectionType());
      collection.ids = collectionData.ids;
    }
    else {
      collection.ids = [];
    }
    return collection;
  }

  updateProjectId(id) {
    this._projectId = id;
  }

  async fetchNext(pageOverride, options) {
    if (dataModel.isOffline) {
      return this.handleOfflineFetch();
    }
    else {
      return new Promise(async (resolve) => {
        if (pageOverride) {
          this.page = pageOverride;
        }
        else this.page++;

        let serviceCall = tasksService.getMyTasks.bind(this, null, false, null, this._projectId, this.page, this.perPage, null, options);
      
        let newCollection = await this._fetchData(serviceCall, options, true);

        newCollection.totalTasks = newCollection.meta ? newCollection.meta.total_tasks : 0;
        newCollection.totalPages = newCollection.meta ? newCollection.meta.total_pages : 0;

        return resolve(newCollection);
      });
    }
  }

  async fetchCurrent(shouldPaginate = true, options = {}) {
    if (dataModel.isOffline) {
      return this.handleOfflineFetch();
    }
    else {
      return new Promise(async (resolve) => {
        let collection = this.findCollection();

        let page = null;
        let perPage = null;
        
        // Get everything we already got
        if (shouldPaginate) {
          page = 1;
          if (collection && collection.perPage) {
            perPage = Math.max(this.perPage, collection.ids.length);
          }
        }
        
        let serviceCall = tasksService.getMyTasks.bind(this, null, false, null, this._projectId, page, perPage, null, options);
    
        let newCollection = await this._fetchData(serviceCall, options);
    
        newCollection.totalTasks = newCollection.meta ? newCollection.meta.total_tasks : 0;
        newCollection.totalPages = newCollection.meta ? newCollection.meta.total_pages : 0;
    
        resolve(newCollection);
      });
    }
  }

  handleOfflineFetch(options) {
    return new Promise((resolve) => {
      let collection = this.getDenormalizedCollection(options);
      if (collection) {
        collection.tasks = dataModel.tasksDAO.getOfflineFilteredTasks(this._projectId, this.statusFilter);
        collection.ids = collection.tasks.map(task => { return task.id; });
      }
      return resolve(collection);
    });
  }

  async processItemActionCable(updatedTask, acData, recordDescriptor) {
    return new Promise((resolve) => {
      const tasksCollection = this.getDenormalizedCollection({ recordDescriptor });
      if (updatedTask && updatedTask.project_id == this._projectId) {
        if (acData.type == 'updateTaskAssignment') {
          if (updatedTask.user_task_assignments &&
            updatedTask.user_task_assignments.filter(user => { return user.user_id == dataModel.usersDAO.currentUser.id; }).length > 0) {
          
            // if the task doesn't exist, add it
            if (!tasksCollection.ids.find(id => { return id == updatedTask.id; })) {
              tasksCollection.tasks.push(updatedTask);
              tasksCollection.meta.total_tasks++;
            }
          }
          else if (tasksCollection.ids.find(id => { return id == updatedTask.id; })) {
            // remove the task
            let found = false;
            tasksCollection.tasks = tasksCollection.tasks.filter(proj => {
              if (proj.id != acData.task_id) {
                return true;
              }
              else {
                found = true;
                return false;
              }
            });
            if (found) {
              tasksCollection.meta.total_tasks--;
            }
          }
          tasksCollection.totalRecords = tasksCollection.totalTasks = tasksCollection.meta.total_tasks;
          tasksCollection.ids = this.normalizeCollection(tasksCollection.tasks, { store: true });
          dataModel.collectionsDAO.setCollection(this.getKey(), tasksCollection, this.getCollectionType());
          return resolve(this.getDenormalizedCollection({ recordDescriptor }));
        }
        if (acData.type == 'updateTask') {
          if (updatedTask) {
            let found = false;
          
            tasksCollection.tasks = tasksCollection.tasks.map(proj => {
              if (proj.id == updatedTask.id) {
                found = true;
                return updatedTask;
              }
              else {
                return proj;
              }
            });
            if (!found) {
              let addTask = false;
              if (updatedTask.user_task_assignments &&
                updatedTask.user_task_assignments.filter(user => { return user.user_id == dataModel.usersDAO.currentUser.id; }).length > 0) {
                addTask = true;
              }
              else if (updatedTask.users &&
                updatedTask.users.filter(user => { return user.id == dataModel.usersDAO.currentUser.id; }).length > 0) {
                addTask = true;
              }
              if (addTask) {
                tasksCollection.tasks.push(updatedTask);
                tasksCollection.meta.total_tasks++;
                tasksCollection.totalRecords = tasksCollection.totalTasks = tasksCollection.meta.total_tasks;
              }
            }
            tasksCollection.ids = this.normalizeCollection(tasksCollection.tasks, { store: true });
            dataModel.collectionsDAO.setCollection(this.getKey(), tasksCollection, this.getCollectionType());
            return resolve(this.getDenormalizedCollection({ recordDescriptor }));
          }
        }
        else if (acData.type == 'deleteTask') {
          let found = false;
          tasksCollection.tasks = tasksCollection.tasks.filter(proj => {
            if (proj.id != acData.task_id) {
              return true;
            }
            else {
              found = true;
              return false;
            }
          });
          if (found) {
            tasksCollection.meta.total_tasks--;
          }
          tasksCollection.totalRecords = tasksCollection.totalTasks = tasksCollection.meta.total_tasks;
          tasksCollection.ids = this.normalizeCollection(tasksCollection.tasks, { store: true });
          dataModel.collectionsDAO.setCollection(this.getKey(), tasksCollection, this.getCollectionType());
          return resolve(this.getDenormalizedCollection({ recordDescriptor }));
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/dao/collections/TasksAssignedByProjectCollection.js